__turbopack_context__.v({
  "accordionSlideOverwrite": "partnerLoginForm-module-scss-module__yXqOna__accordionSlideOverwrite",
  "checkbox": "partnerLoginForm-module-scss-module__yXqOna__checkbox",
  "checkboxItem": "partnerLoginForm-module-scss-module__yXqOna__checkboxItem",
  "fadeIn": "partnerLoginForm-module-scss-module__yXqOna__fadeIn",
  "fadeOut": "partnerLoginForm-module-scss-module__yXqOna__fadeOut",
  "forgotPasswordLink": "partnerLoginForm-module-scss-module__yXqOna__forgotPasswordLink",
  "form": "partnerLoginForm-module-scss-module__yXqOna__form",
  "inputField": "partnerLoginForm-module-scss-module__yXqOna__inputField",
  "inputWrapper": "partnerLoginForm-module-scss-module__yXqOna__inputWrapper",
  "label": "partnerLoginForm-module-scss-module__yXqOna__label",
  "rememberMeContainer": "partnerLoginForm-module-scss-module__yXqOna__rememberMeContainer",
  "scaleIn": "partnerLoginForm-module-scss-module__yXqOna__scaleIn",
  "scaleOut": "partnerLoginForm-module-scss-module__yXqOna__scaleOut",
  "zoomIn": "partnerLoginForm-module-scss-module__yXqOna__zoomIn",
  "zoomOut": "partnerLoginForm-module-scss-module__yXqOna__zoomOut",
});
